<template>
  <div :id="`splitable-resize-container-${id}`" class="splitable-resize-container" :style="`
        ${width ? `width: ${width};` : ''}
              ${height ? `height: ${height};` : ''}
              ${direction ? `flex-direction: ${direction};` : ''}
      `">
    <template v-for="(child, index) in my_children">
      <div :key="`splitable-resize-container-child-${index}`" class="splitable-resize-container-child"
        :id="`splitable-resize-container-child-${id}-${index}`" :style="`
          width: ${direction === 'row' ? `calc(${child.size} - ${slider_size / 2}px ${index !== 0 && index !== my_children.length - 1 ? `- ${slider_size / 2}px` : ''})` : '100%'};
                                  height: ${direction === 'row' ? '100%' : `calc(${child.size} - ${slider_size / 2}px ${index !== 0 && index !== my_children.length - 1 ? `- ${slider_size / 2}px` : ''})`};
        `">
        <slot :name="`slot-${index + 1}`" :child="index === my_children.length - 1 ? my_children[index-1]: child" :resize_id="`splitable-resize-container-child-${id}-${index === my_children.length - 1 ? index - 1 : index}-resizer`"></slot>
      </div>
      <!-- && $slots[`slot-${index+1}`] -->
      <div v-if="index !== my_children.length - 1" :key="`splitable-resize-container-slider-${index}`"
        :id="`splitable-resize-container-child-${id}-${index}-resizer`"
        class="splitable-resize-container-slider" :style="`
          width: ${direction === 'row' ? `${slider_size}px` : '100%'};
                                  height: ${direction === 'row' ? '100%' : `${slider_size}px`};
                                  cursor: ${direction === 'row' ? 'col-resize' : 'row-resize'};
                                  
        `" @mousedown="sliderMouseDown($event, index)" @dblclick="minMaxSize(index)">
        <!-- background-color: ${child.minimized ? 'white' : ''}; -->
        <!-- to do here the slider style -->
        <div class="slider-grab"></div>
      </div>
    </template>
  </div>
</template>
<script>

export default {
  props: [
    'id',
    'width', // in px or % or etc
    'height', // in px or % or etc
    'direction', // column or row
    'children',
    // size in %
    // min_value, max_value in px as integer


    // cont, w-minimatch, w-maxHeaderSize, h-minimatch, h-max, areas count , x, y, area specific serialize, slider x/y 
  ],
  data: () => ({
    slider_size: 6,
    slider_mouse_down_index: -1,
    slider_initial_value: 0,
    container_initial_value_left: 0,
    container_initial_value_right: 0,
    silder_el_left: {},
    silder_el_right: {},
    object_left: {},
    object_right: {},
    my_children: [],
  }),
  created() {
    window.addEventListener("mouseup", this.applyNewSize);
    window.addEventListener("mousemove", this.sliderMouseMove);
    for (let index = 0; index < this.children.length; index++) {
      // create copy of child, add minimized = false and push to my_children
      const child = this.children[index];
      let new_child = {
        ...child,
        minimized: false
      }
      this.my_children.push(new_child);
    }
  },
  methods: {
    minMaxSize(index) {
      // to do
      let clicked_child = this.my_children[index];

      let og_clicked_child = null;

      if (clicked_child.minimize === false) {
        for (let iter_index = index; iter_index < this.my_children.length; iter_index++) {
          if (this.my_children[iter_index].minimize !== false) {
            og_clicked_child = clicked_child;
            clicked_child = this.my_children[iter_index];
            break;
          }
        }
      }

      if (clicked_child.minimize === false) {
        return;
      }

      this.slider_mouse_down_index = index;
      this.object_left = document.getElementById(`splitable-resize-container-child-${this.id}-${this.slider_mouse_down_index}`);
      this.object_right = document.getElementById(`splitable-resize-container-child-${this.id}-${this.slider_mouse_down_index + 1}`);
      let size;
      let left_size, right_size;
      if (this.direction === 'row') {
        left_size = this.object_left.offsetWidth;
        right_size = this.object_right.offsetWidth;
      } else {
        left_size = this.object_left.offsetHeight;
        right_size = this.object_right.offsetHeight;
      }
      if (clicked_child.minimize === 'left') {
        size = this.minMaxSizeValuesOnlyLeftSize(left_size, right_size, clicked_child, og_clicked_child);
      } else {
        size = this.minMaxSizeValuesOnlyRightSize(left_size, right_size, clicked_child, og_clicked_child);
      }

      if (this.direction === 'row') {
        this.object_left.style.width = `${size.left}px`;
        this.object_right.style.width = `${size.right}px`;
      } else {
        this.object_left.style.height = `${size.left}px`;
        this.object_right.style.height = `${size.right}px`;
      }


      this.applyNewSize();
    },
    minMaxSizeValuesOnlyLeftSize(left_size, right_size, clicked_child, og_clicked_child) {
      let new_size = {
        left: 0,
        right: 0
      }
      if (left_size === 0 || left_size === clicked_child.min_size) {
        // expand to default size
        new_size.left = clicked_child.old_size;
        new_size.right = right_size - clicked_child.old_size;
        if (og_clicked_child) {
          og_clicked_child.minimized = false;
        } else {
          clicked_child.minimized = false;
        }
      } else {
        clicked_child.old_size = left_size;
        new_size.right = right_size + left_size;
        if (clicked_child.min_size) {
          new_size.left = clicked_child.min_size;
        } else {
          new_size.left = 0;
        }
        if (og_clicked_child) {
          og_clicked_child.minimized = true;
        } else {
          clicked_child.minimized = true;
        }
      }

      return new_size;
    },
    minMaxSizeValuesOnlyRightSize(left_size, right_size, clicked_child, og_clicked_child) {
      let new_size = {
        left: 0,
        right: 0
      }
      if (right_size === 0 || right_size === clicked_child.min_size) {
        // expand to default size
        new_size.left = right_size - clicked_child.old_size;
        new_size.right = clicked_child.old_size;
        if (og_clicked_child) {
          og_clicked_child.minimized = false;
        } else {
          clicked_child.minimized = false;
        }
      } else {
        clicked_child.old_size = right_size;
        new_size.left = left_size + right_size;
        if (clicked_child.min_size) {
          new_size.right = clicked_child.min_size;
        } else {
          new_size.right = 0;
        }
        if (og_clicked_child) {
          og_clicked_child.minimized = true;
        } else {
          clicked_child.minimized = true;
        }
      }

      return new_size;
    },
    sliderMouseDown(event, index) {
      this.my_children[index].minimized = false;
      this.slider_mouse_down_index = index;
      this.object_left = document.getElementById(`splitable-resize-container-child-${this.id}-${this.slider_mouse_down_index}`);
      this.object_right = document.getElementById(`splitable-resize-container-child-${this.id}-${this.slider_mouse_down_index + 1}`);
      this.silder_el_left = this.my_children[index];
      this.silder_el_right = this.my_children[index + 1];
      if (this.direction === 'row') {
        this.slider_initial_value = event.screenX;
        this.container_initial_value_left = this.object_left.offsetWidth;
        this.container_initial_value_right = this.object_right.offsetWidth;
      } else {
        this.slider_initial_value = event.screenY;
        this.container_initial_value_left = this.object_left.offsetHeight;
        this.container_initial_value_right = this.object_right.offsetHeight;
      }
    },
    applyNewSize() {
      if (this.slider_mouse_down_index !== -1) {
        this.slider_mouse_down_index = -1;
        let container = document.getElementById(`splitable-resize-container-${this.id}`);
        if (this.direction === 'row') {
          this.object_left.style.width = `${this.object_left.offsetWidth / container.offsetWidth * 100}%`;
          this.object_right.style.width = `${this.object_right.offsetWidth / container.offsetWidth * 100}%`;
        } else {
          this.object_left.style.height = `${this.object_left.offsetHeight / container.offsetHeight * 100}%`;
          this.object_right.style.height = `${this.object_right.offsetHeight / container.offsetHeight * 100}%`;
        }
      }
    },
    sliderMouseMove(event) {
      if (this.slider_mouse_down_index !== -1) {
        let value;
        if (this.direction === 'row') {
          value = event.screenX;
        } else {
          value = event.screenY;
        }
        let difference = this.slider_initial_value - value;
        // let object_left = document.getElementById(`splitable-resize-container-child-${this.id}-${this.slider_mouse_down_index}`);
        // let object_right = document.getElementById(`splitable-resize-container-child-${this.id}-${this.slider_mouse_down_index+1}`);

        let left_new_size = this.container_initial_value_left - difference;
        let right_new_size = this.container_initial_value_right + difference;

        // EDGE CASES
        if (this.silder_el_left.min_size && left_new_size < this.silder_el_left.min_size) {
          right_new_size = right_new_size - (this.silder_el_left.min_size - left_new_size)
          left_new_size = this.silder_el_left.min_size;
        }
        if (this.silder_el_left.max_size && left_new_size > this.silder_el_left.max_size) {
          right_new_size = right_new_size + (left_new_size - this.silder_el_left.max_size)
          left_new_size = this.silder_el_left.max_size;
        }
        if (this.silder_el_right.min_size && right_new_size < this.silder_el_right.min_size) {
          left_new_size = left_new_size - (this.silder_el_right.min_size - right_new_size)
          right_new_size = this.silder_el_right.min_size;
        }
        if (this.silder_el_right.max_size && right_new_size > this.silder_el_right.max_size) {
          left_new_size = left_new_size + (right_new_size - this.silder_el_right.max_size)
          right_new_size = this.silder_el_right.max_size;
        }
        if (left_new_size < 0) {
          left_new_size = 0;
        }
        if (right_new_size < 0) {
          right_new_size = 0;
        }

        if (this.direction === 'row') {
          this.object_left.style.width = `${left_new_size}px`;
          this.object_right.style.width = `${right_new_size}px`;
        } else {
          this.object_left.style.height = `${left_new_size}px`;
          this.object_right.style.height = `${right_new_size}px`;
        }

      }
    },
  }
}
</script>
<style>
.splitable-resize-container {
  position: relative;
  display: flex;
  flex-direction: column;
}

.splitable-resize-container-child {
  display: flex;
  flex-direction: column;
  /* border: 1px solid white; */
  user-select: none;
  /* padding: 0 3px; */
  overflow: hidden;
  /* SChwierig, mit: screen and Content dont overflow, but TTip prisioned in content */
  gap: 5px;
}

.splitable-resize-container-slider {
  /* border: 1px solid red; */
  /* background-color: purple; */
  pointer-events: all;
  width: 100%;
  height: 100%;
}
</style>
  